import Types from './types';
import Api from '@/services/api';
import history from '@/store/history';

export const setSession = (payload) => ({
	type: Types.AUTH_SET_SESSION,
	payload
});

export const handleLogout = () => {
	localStorage.clear();
	Api.defaults.headers.Authorization = undefined;
	history.push('/login');
	return { type: Types.LOGOUT };
};

export const controlSpinnerRoute = () => {
	return { type: Types.SPINNER_ROUTE };
};

export const isAuthenticated = (parameters) => {
	return { type: Types.AUTHENTICATED, payload: parameters };
};
